import { datalabHttp, datalabWithTokenHttp, type TDatalabHttpConfig } from '@dbl/services/common';
import type {
  IEventRecordConfig,
  IGetCommonDimensionInfoRequest,
  IGetSelectorRequest,
} from './types';

const SELECTOR_REQUEST_TIMEOUT_MS = 120000;

/**
 * 获取通用维度信息（筛选器/维度面板共用）。
 *
 * 接口：`POST /api/v1/datalab/getCommonDimensionInfo`；存量：`getCommonDimensionInfo`。
 */
export function getCommonDimensionInfo(
  params: IGetCommonDimensionInfoRequest,
): Promise<unknown> {
  return datalabHttp({
    url: '/api/v1/datalab/getCommonDimensionInfo',
    method: 'post',
    data: params,
  });
}

/**
 * 获取事件记录等通用配置。
 *
 * 接口：`POST /api/v1/datalab/get_event_record`；存量：`getCommonConfig`。
 */
export function getCommonConfig(
  gameCode: string,
): Promise<IEventRecordConfig> {
  return datalabWithTokenHttp({
    url: '/api/v1/datalab/get_event_record',
    method: 'post',
    data: {
      game_code: gameCode,
    },
  });
}

/**
 * 拉取经分平台通用筛选器元数据（地区、国家等）。
 *
 * 接口：`POST /api/v1/dashboard/selector`；存量：`ExplorationAnalysis/service.ts` -> getSelector。
 * 经分侧同名封装：`loadFilterList`（`pages/dashboard/services/dashboard.ts`）。
 */
export function getSelector(params: IGetSelectorRequest): Promise<unknown> {
  return datalabHttp({
    url: '/api/v1/dashboard/selector',
    method: 'post',
    data: params,
    timeout: SELECTOR_REQUEST_TIMEOUT_MS,
  } as TDatalabHttpConfig);
}
